export { default } from './TaggisAndDocBrowser';



// WEBPACK FOOTER //
// ./src/components/templates/TaggisAndDocBrowser/index.js